import { render, staticRenderFns } from "./StudioProductGiftCheckout.vue?vue&type=template&id=6ed63130&scoped=true&"
import script from "./StudioProductGiftCheckout.vue?vue&type=script&lang=js&"
export * from "./StudioProductGiftCheckout.vue?vue&type=script&lang=js&"
import style0 from "./StudioProductGiftCheckout.vue?vue&type=style&index=0&id=6ed63130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed63130",
  null
  
)

export default component.exports